import styled from "styled-components";

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/ol

export const OL = styled.ol`
  li {
    display: list-item !important;
  }
`;

export const OL_1 = styled(OL)`
  padding: 0 0 0 20px;
  margin: 0;
`;
